import React from "react";
// core components
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.js";

const initState = {
    genericList: null,
    reloadList: false,
    data: null,
    successMessage: null,
    listError: null,
    error: null,
    loading: null,
}

const catalogoEmpleadosReducer = (state = initState, action) => {
    
    switch (action.type) {
        case "CATALOGO_EMPLEADOS_LIST":
            return {
                ...state,
                genericList: action.payload.data,
                reloadList: false,
                loading: null,
                listError: null,
            }        
        case "CATALOGO_EMPLEADOS_GET":
            return {
                ...state,
                data: action.payload.data,
                loading: null,
            }
        case "CATALOGO_EMPLEADOS_GUARDADO":
            return {
                ...state,
                successMessage: action.payload.mensaje,
                reloadList: true,
                loading: null,
            }                
        case "CATALOGO_EMPLEADOS_STATUS_ACTUALIZADO":
            return {
                ...state,
                reloadList: true,
                loading: null,
            }             
        case "CATALOGO_EMPLEADOS_NOMBRE_CORTO_ACTUALIZADO":
            return {
                ...state,
                successMessage: action.payload.mensaje,
                loading: null,
            } 
        case "CATALOGO_EMPLEADOS_PASSWORD_ACTUALIZADO":
            return {
                ...state,
                successMessage: action.payload.mensaje,
                loading: null,
            } 
        case "CATALOGO_EMPLEADOS_PASSWORD_RESETEADO":
            return {
                ...state,
                successMessage: action.payload.mensaje,
                loading: null,
            }                
        case "CATALOGO_EMPLEADOS_AVATAR_ACTUALIZADO":
            return {
                ...state,
                successMessage: action.payload.mensaje,
                loading: null,
            }                                    
        case "CATALOGO_EMPLEADOS_ERROR":
            return {
                ...state,
                error: action.payload.error,   
                loading: null,                     
            }
        case "CATALOGO_EMPLEADOS_LIST_ERROR":
            return {
                ...state,
                listError: action.payload.error,   
                loading: null,                     
            }
        case "CATALOGO_EMPLEADOS_LIMPIAR_MENSAJES": {
            return {
                ...state,
                successMessage: null,
                error: null,
                listError: null,
            }
        }            
        case "CATALOGO_EMPLEADOS_LOADING": {
            return {
                ...state,
                loading: (<CustomLinearProgress color="info" />),
            }
        }                        
        default:
            return state;
    }
}

export default catalogoEmpleadosReducer;